import type { FC } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { INSPIRATION_IDS } from "web_myplann/Inspiration/constants";
import { EarlyFreedomInspirationPage } from "web_myplann/Inspiration/Pages/EarlyFreedomInspirationPage";
import { OwnHomeInspirationPage } from "web_myplann/Inspiration/Pages/OwnHomeInspirationPage";

const PAGES: Record<string, FC> = {
	[INSPIRATION_IDS.ownHome]: OwnHomeInspirationPage,
	[INSPIRATION_IDS.earlyFreedom]: EarlyFreedomInspirationPage,
};

export const InspirationDetailPage: FC = () => {
	const { id } = useParams();
	const Page = id ? PAGES[id] : undefined;

	if (!Page) return <Navigate to={Routing.Dashboard.path()} replace />;
	return <Page />;
};
